/** Please don't modify or unzip this content. It will be updated regularly **/
(function() {
  BoostPFS.inject(this);

  //Set global variable
  Globals.hasIntegration = true;

  function getLooxMetafield(data, key) {
  if (typeof Utils !== 'undefined' && typeof Utils.getProductMetafield === 'function') {
    var value = Utils.getProductMetafield(data, 'loox', key);
    if (value !== null && typeof value !== 'undefined') return value;
  }
  if (data && data.metafields && data.metafields.loox && typeof data.metafields.loox[key] !== 'undefined') {
    return data.metafields.loox[key];
  }
  return '';
}

function escapeLooxAttribute(value) {
  return String(value == null ? '' : value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function isValidLooxReviewData(rating, raters) {
  return rating !== '' && raters !== '' && isFinite(rating) && isFinite(raters) && Number(rating) > 0 && Number(rating) <= 5 && Number(raters) > 0 && Math.floor(Number(raters)) === Number(raters);
}

function getLooxProductHandle(data) {
  if (data && data.handle) return String(data.handle);
  var url = data && data.url ? String(data.url) : '';
  var match = url.match(/\/products\/([^?#/]+)/);
  return match ? match[1] : '';
}

function buildLooxReviews(data) {
  var ratingValue = getLooxMetafield(data, 'avg_rating');
  var ratersValue = getLooxMetafield(data, 'num_reviews');
  var productUrl = data && data.url ? data.url : (data && data.handle ? '/products/' + data.handle : '#');
  if (!data || !data.id) return '';
  if (!isValidLooxReviewData(ratingValue, ratersValue)) {
    var handle = getLooxProductHandle(data);
    if (!handle) return '';
    return "<a class='loox-rating-link' href='" + escapeLooxAttribute(productUrl) + "#looxReviews'><span class='fa-loox-rating-shell' data-fa-loox-id='" + escapeLooxAttribute(data.id) + "' data-fa-loox-handle='" + escapeLooxAttribute(handle) + "'></span></a>";
  }
  var rating = escapeLooxAttribute(ratingValue);
  var raters = escapeLooxAttribute(ratersValue);
  return "<a class='loox-rating-link' href='" + escapeLooxAttribute(productUrl) + "#looxReviews'><div class='loox-rating' data-id='" + escapeLooxAttribute(data.id) + "' data-rating='" + rating + "' data-raters='" + raters + "' data-pattern='[count] avis'></div></a>";
}

  // 3rd app compile template
  Integration.compileIntegrationTemplate = function (data, itemHtml) {
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildLooxReviews(data));
    return itemHtml;
  };
})();
